/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Remove
 */
export interface Remove {
    /**
     * 
     * @type {string}
     * @memberof Remove
     */
    message: string;
}

/**
 * Check if a given object implements the Remove interface.
 */
export function instanceOfRemove(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function RemoveFromJSON(json: any): Remove {
    return RemoveFromJSONTyped(json, false);
}

export function RemoveFromJSONTyped(json: any, ignoreDiscriminator: boolean): Remove {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': json['message'],
    };
}

export function RemoveToJSON(value?: Remove | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
    };
}

